'use client';

import { useEffect } from 'react';
import { locales, DEFAULT_LOCALE } from '@/locales';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Global error:', error);
  }, [error]);

  const locale = DEFAULT_LOCALE; // TODO: get current locale
  const t = locales[locale] ?? locales[DEFAULT_LOCALE];

  return (
    <html>
      <body className="bg-surface-950 text-white">
        <div className="min-h-screen flex items-center justify-center px-4">
          <div className="text-center">
            <p className="text-6xl mb-4">⚠️</p>
            <h2 className="text-xl font-semibold mb-3">{t.globalError.title}</h2>
            <p className="text-gray-500 text-sm mb-6">{t.globalError.subtitle}</p>
            <button
              onClick={() => reset()}
              className="bg-gradient-brand text-white font-medium px-6 py-3 rounded-2xl hover:brightness-110 transition-all"
            >
              {t.globalError.retry}
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
